import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import { ColorModeContext } from "../../../../theme/ColorModeContext";

export const ColorModeToggle: React.FC = () => {
  const { mode, toggleColorMode } = React.useContext(ColorModeContext);
  const isDark = mode === "dark";

  return (
    <Tooltip title={isDark ? "Light mode" : "Dark mode"}>
      <IconButton
        className="icon-color"
        aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
        onClick={toggleColorMode}
      >
        {isDark ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );
};
